(() => {
  const { routes, strings } = window.theme || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  /* Dialogs */
  const openDialog = (dialog) => {
    if (!dialog || dialog.open) return;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  };
  document.addEventListener('close', (e) => {
    if (e.target.tagName === 'DIALOG') document.documentElement.style.overflow = '';
  }, true);
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.openDialog);
      openDialog(dialog);
      $('input[type="search"]', dialog)?.focus();
      return;
    }
    if (e.target.closest('[data-close-dialog]')) {
      e.target.closest('dialog')?.close();
      return;
    }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* Cart */
  const cartDrawer = () => document.getElementById('cart-drawer');

  const renderCart = (sections) => {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const next = $('[data-cart-drawer-inner]', parse(html));
    const current = $('[data-cart-drawer-inner]');
    if (!next || !current) return;
    current.replaceWith(next);
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = next.dataset.count;
      el.dataset.count = next.dataset.count;
    });
  };

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-open-cart]');
    if (!link || !cartDrawer() || document.body.dataset.template === 'cart') return;
    e.preventDefault();
    openDialog(cartDrawer());
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const button = $('[type="submit"]', form) || $('[data-add-button]');
    const error = $('[data-form-error]', form);
    button?.classList.add('is-loading');
    if (error) error.hidden = true;
    const body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', location.pathname);
    try {
      const res = await fetch(`${routes.cartAdd}.js`, { method: 'POST', body, headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || strings.addError);
      renderCart(data.sections);
      openDialog(cartDrawer());
    } catch (err) {
      if (error) {
        error.textContent = err.message || strings.addError;
        error.hidden = false;
      } else {
        alert(err.message || strings.addError);
      }
    } finally {
      button?.classList.remove('is-loading');
    }
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    btn.disabled = true;
    const res = await fetch(`${routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Math.max(0, Number(btn.dataset.qty)), sections: 'cart-drawer' }),
    });
    if (document.body.dataset.template === 'cart') return location.reload();
    if (res.ok) renderCart((await res.json()).sections);
    btn.disabled = false;
  });

  /* Predictive search */
  const searchInput = $('[data-predictive-input]');
  const searchResults = $('[data-predictive-results]');
  if (searchInput && searchResults) {
    let timer;
    let controller;
    searchInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = searchInput.value.trim();
      if (q.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      timer = setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        const params = new URLSearchParams({
          q,
          section_id: 'predictive-search',
          'resources[type]': 'product,collection',
          'resources[limit]': '6',
          'resources[options][prefix]': 'last',
        });
        try {
          const res = await fetch(`${routes.predictiveSearch}?${params}`, { signal: controller.signal });
          const doc = parse(await res.text());
          searchResults.innerHTML = $('.shopify-section', doc)?.innerHTML || '';
        } catch (err) {
          if (err.name !== 'AbortError') searchResults.innerHTML = '';
        }
      }, 220);
    });
  }

  /* Header: hidden while scrolling down, shown when scrolling up */
  const headerSection = $('.section-header');
  if (headerSection) {
    let lastY = scrollY;
    addEventListener('scroll', () => {
      const y = Math.max(0, scrollY);
      const delta = y - lastY;
      if (Math.abs(delta) < 6) return;
      const busy = $('.nav__item.is-open') || $('dialog[open]');
      headerSection.classList.toggle('is-hidden', delta > 0 && y > headerSection.offsetHeight * 2 && !busy);
      lastY = y;
    }, { passive: true });
  }

  /* Mega menu */
  $$('[data-nav-item]').forEach((item) => {
    const link = $('.nav__link', item);
    let timer;
    const set = (open) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        item.classList.toggle('is-open', open);
        link.setAttribute('aria-expanded', String(open));
      }, open ? 60 : 140);
    };
    item.addEventListener('pointerenter', (e) => e.pointerType === 'mouse' && set(true));
    item.addEventListener('pointerleave', (e) => e.pointerType === 'mouse' && set(false));
    item.addEventListener('focusin', () => set(true));
    item.addEventListener('focusout', (e) => !item.contains(e.relatedTarget) && set(false));
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        set(false);
        link.focus();
      }
    });
  });

  /* Card tilt */
  if (document.body.dataset.tilt === 'true' && !reducedMotion && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let frame;
    document.addEventListener('pointermove', (e) => {
      const card = e.target.closest?.('[data-tilt-card]');
      if (!card) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const stage = $('.card__stage', card);
        const r = stage.getBoundingClientRect();
        const x = Math.min(Math.max((e.clientX - r.left) / r.width, 0), 1);
        const y = Math.min(Math.max((e.clientY - r.top) / r.height, 0), 1);
        card.classList.add('is-tilting');
        stage.style.setProperty('--mx', `${x * 100}%`);
        stage.style.setProperty('--my', `${y * 100}%`);
        stage.style.setProperty('--rx', `${(0.5 - y) * 7}deg`);
        stage.style.setProperty('--ry', `${(x - 0.5) * 9}deg`);
      });
    });
    document.addEventListener('pointerout', (e) => {
      const card = e.target.closest?.('[data-tilt-card]');
      if (!card || card.contains(e.relatedTarget)) return;
      cancelAnimationFrame(frame);
      card.classList.remove('is-tilting');
      const stage = $('.card__stage', card);
      stage.style.setProperty('--rx', '0deg');
      stage.style.setProperty('--ry', '0deg');
    });
  }

  /* Rails and tabs */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-rail-step]');
    if (step) {
      const track = $$('[data-rail-track]', step.closest('[data-rail]')).find((t) => !t.closest('[hidden]'));
      track?.scrollBy({ left: Number(step.dataset.railStep) * track.clientWidth * 0.9, behavior: reducedMotion ? 'auto' : 'smooth' });
      return;
    }
    const tab = e.target.closest('[data-tab]');
    if (tab) {
      const rail = tab.closest('[data-rail]');
      $$('[data-tab]', rail).forEach((t) => {
        const active = t === tab;
        t.setAttribute('aria-selected', String(active));
        document.getElementById(t.getAttribute('aria-controls')).hidden = !active;
      });
    }
  });

  /* Collection filters */
  const filters = $('[data-filters]');
  const grid = $('[data-grid]');
  if (filters && grid) {
    const url = new URL(location.href);
    // ?format= is reserved by Shopify (response type, e.g. ?format=json) and 404s, so the URL uses ?fmt=
    const param = (key) => (key === 'format' ? 'fmt' : key);
    const state = {
      format: url.searchParams.get('fmt') || '',
      lang: url.searchParams.get('lang') || '',
      stock: url.searchParams.get('stock') || '',
    };
    const count = $('[data-results-count]');
    const empty = $('[data-filter-empty]');

    const apply = () => {
      let visible = 0;
      $$('.card', grid).forEach((card) => {
        const show =
          (!state.format || card.dataset.format === state.format) &&
          (!state.lang || card.dataset.lang === state.lang) &&
          (!state.stock || card.dataset.available === 'true');
        card.hidden = !show;
        if (show) visible += 1;
      });
      $$('[data-filter]', filters).forEach((pill) => {
        pill.setAttribute('aria-pressed', String(state[pill.dataset.filter] === pill.dataset.value));
      });
      if (count) count.textContent = visible === 1 ? count.dataset.labelOne : count.dataset.labelOther.replace('__n__', visible);
      if (empty) empty.hidden = visible > 0;
      const next = new URL(location.href);
      Object.entries(state).forEach(([key, value]) => (value ? next.searchParams.set(param(key), value) : next.searchParams.delete(param(key))));
      history.replaceState(null, '', next);
    };

    filters.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-filter]');
      if (!pill) return;
      const { filter, value } = pill.dataset;
      state[filter] = filter !== 'format' && state[filter] === value ? '' : value;
      apply();
    });
    $('[data-filter-reset]')?.addEventListener('click', () => {
      state.format = state.lang = state.stock = '';
      apply();
    });
    $('[data-sort-select]')?.addEventListener('change', (e) => {
      const next = new URL(location.href);
      next.searchParams.set('sort_by', e.target.value);
      next.searchParams.delete('page');
      location.href = next;
    });
    if (state.format || state.lang || state.stock) apply();
  }

  /* Product page */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const input = $('input', step.closest('.qty'));
      const max = Number(input.max) || Infinity;
      input.value = Math.min(max, Math.max(1, Number(input.value) + Number(step.dataset.qtyStep)));
      return;
    }
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const slides = $('[data-slides]');
      slides.scrollTo({ left: slides.clientWidth * Number(thumb.dataset.thumb), behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  });

  const slides = $('[data-slides]');
  if (slides) {
    slides.addEventListener('scroll', () => {
      const index = Math.round(slides.scrollLeft / slides.clientWidth);
      $$('[data-thumb]').forEach((t) => t.setAttribute('aria-current', String(Number(t.dataset.thumb) === index)));
    }, { passive: true });
  }

  const variantSelect = $('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      $$('[data-price]').forEach((price) => {
        $('.price__now', price).textContent = option.dataset.price;
        $('.price__from', price)?.remove();
        let was = $('.price__was', price);
        if (option.dataset.compare) {
          if (!was) {
            was = document.createElement('s');
            was.className = 'price__was';
            price.append(was);
          }
          was.textContent = option.dataset.compare;
        } else {
          was?.remove();
        }
        price.classList.toggle('price--sale', Boolean(option.dataset.compare));
      });
      const next = new URL(location.href);
      next.searchParams.set('variant', option.value);
      history.replaceState(null, '', next);
    });
  }

  const sticky = $('[data-sticky-atc]');
  const mainButton = $('[data-add-button]');
  if (sticky && mainButton) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      $('button', sticky).tabIndex = show ? 0 : -1;
    }).observe(mainButton);
  }
})();
